import { Days } from "./calendar.enums";

export const MONTHS = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];

export const FIRST_DAY_OF_WEEK = Days.Monday;

export const YEAR_SELECTOR_YEAR_COUNT = 10;

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
